import { render } from "./MyTransportBookings.vue?vue&type=template&id=5d1ab0b9&scoped=true"
import script from "./MyTransportBookings.vue?vue&type=script&lang=js"
export * from "./MyTransportBookings.vue?vue&type=script&lang=js"

import "./MyTransportBookings.vue?vue&type=style&index=0&id=5d1ab0b9&lang=css"
import "./MyTransportBookings.vue?vue&type=style&index=1&id=5d1ab0b9&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d1ab0b9"]])

export default __exports__